import { render, staticRenderFns } from "./FilesHeader.vue?vue&type=template&id=eef7c56a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eef7c56a')) {
      api.createRecord('eef7c56a', component.options)
    } else {
      api.reload('eef7c56a', component.options)
    }
    module.hot.accept("./FilesHeader.vue?vue&type=template&id=eef7c56a&", function () {
      api.rerender('eef7c56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/FilesHeader.vue"
export default component.exports